

const INDIVIDUAL_CONDITIONS_ROUTES = {
	path: "realization/individual-conditions",
	name: "individual-conditions",
	component: () => import("@/views/pages/Realization/individualConditions/IndividualConditionsPage.vue"),
};

export default INDIVIDUAL_CONDITIONS_ROUTES;